/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const customerName = queryKey[2];
  const company = queryKey[3];

  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.get_customer?name=${customerName}&company=${company}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchCustomer = (customerName: string) => {
  const { url } = useSelector(selectAuth);
  const { data: profile } = useFetchPosProfileDetails();

  return useQuery(['customer', url, customerName, profile?.company], fetcher);
};
